module.exports = __webpack_public_path__ + "img/lab-icon-old.c58d997f.png";